import Api from './Api';

class LogicBaseFeaturedApi extends Api {
  url = 'logicbasefeatured';

  /**
   * Public homepage read. A failed response (404 HTML, 500, network error)
   * settles as an empty page so the hero pager stops refetching on every render.
   * `null` means the same request is already in flight — leave it pending.
   */
  async query(_query, _params, _returnFullResponse) {
    const results = await super.query(_query, _params, _returnFullResponse);
    if (_returnFullResponse || results === null) return results;
    return Array.isArray(results) ? results : [];
  }
}

const singleton = new LogicBaseFeaturedApi();
export default singleton;
